// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"243":"ec296002","270":"164de4f1","301":"d6f031cc","490":"084a6439","544":"39ac4c77","567":"aa73cfae","645":"35e06947","829":"2350d8d1","834":"12c5ecf1","952":"a1557dc2"}[chunkId] + ".chunk.js";
};